import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileTypeIcon'
})
export class FileTypeIconPipe implements PipeTransform {
  transform(fileRef: string): string {
    const extension = this.getExtension(fileRef);

    if (extension === 'pdf') {
      return 'assets/images/file-icons/pdf.svg';
    }

    if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'svg', 'heic', 'heif', 'tif', 'tiff'].includes(extension)) {
      return 'assets/images/file-icons/image.svg';
    }

    if (['doc', 'docx'].includes(extension)) {
      return 'assets/images/file-icons/word.svg';
    }

    if (['xls', 'xlsx'].includes(extension)) {
      return 'assets/images/file-icons/excel.svg';
    }

    if (['ppt', 'pptx'].includes(extension)) {
      return 'assets/images/file-icons/powerpoint.svg';
    }

    if (['txt', 'csv'].includes(extension)) {
      return 'assets/images/file-icons/text.svg';
    }

    return 'assets/images/file-icons/other.svg';
  }

  private getExtension(fileRef: string): string {
    if (!fileRef) {
      return '';
    }

    const normalizedRef = `${fileRef}`.trim().toLowerCase();
    if (!normalizedRef) {
      return '';
    }

    const sanitizedRef = normalizedRef.split('#')[0].split('?')[0];
    const nameCandidate = sanitizedRef.split('/').pop() || sanitizedRef;
    const extension = nameCandidate.includes('.')
      ? nameCandidate.split('.').pop()
      : '';

    return extension || '';
  }
}
